import React from "react"
import Showcase from "../components/Showcase"
import { Chart } from "react-ame-components"
export class ChartLineExample extends React.Component {
  state = {
    labels: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho"],
    dataOptions: [
      {
        label: "Prata",
        data: [7, 2, 6, 10, 100, 4],
        lineColor: "blue",
        color: "blue",
      },
      {
        label: "Ouro",
        data: [10, 20, 10, 40, 10, 10],
        lineColor: "orange",
        color: "orange",
      },
    ],
  }

  render() {
    return (
      <Showcase
        title="Componente Chart.Line"
        description="Este componente serve para exibir um gráfico de linhas.">
        <Chart.Line
          data={this.state.dataOptions}
          labels={this.state.labels}
          title="Gráfico Line"
        />
      </Showcase>
    )
  }
}
